import React from 'react';
import { PasswordInput, Stack, Group } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { validatePassword } from '../../utils/passwordValidation';

function PasswordRequirementInput({ 
  value, 
  onChange, 
  label = "Password",
  placeholder = "Enter password",
  error,
  showRequirements = true,
  ...props 
}) {
  const requirements = validatePassword(value);
  const checks = requirements.map((requirement) => (
    <Group
      key={requirement.id}
      c={requirement.meets ? 'green' : 'red'}
      align="center"
      gap={8}
    >
        {requirement.meets ? <IconCheck size={16} /> : <IconX size={16} />}
        {requirement.label}
    </Group>
  ));

  return (
    <Stack gap="xs">
      <PasswordInput
        value={value}
        onChange={onChange}
        label={label}
        placeholder={placeholder}
        error={error}
        {...props}
      />
      
      {showRequirements && (
        <Stack gap={2}>
          {checks}
        </Stack>
      )}
    </Stack>
  );
}

export default PasswordRequirementInput; 